import React, { type ReactNode } from 'react';
import ImgVip from './img-vip.png';

interface Props {
  showVip?: boolean;
  vipPosition?: 'start' | 'end';
  children: ReactNode;
}

function VipWrapper({ showVip, vipPosition, children }: Props) {
  return (
    <>
      {showVip && vipPosition === 'start' && (
        <img
          src={ImgVip}
          alt=""
          className="mx-5 h-16 w-16 flex-shrink-0 self-center"
        />
      )}
      {children}
      {showVip && vipPosition !== 'start' && (
        <img
          src={ImgVip}
          alt=""
          className="mx-5 h-16 w-16 flex-shrink-0 self-center"
        />
      )}
    </>
  );
}

export default VipWrapper;
